import { SearchField } from './searchField';

export class SearchFilters {
  //public searchTerm: string = "";
  public filters: SearchField[] = [];
  public returnMerchants: boolean = false; // this is "Business" (used to be "Location" or "Merchant")
  public returnBusinesses: boolean = false; // this is "Account"
  public returnCustomers: boolean = false;
  public returnTransactions: boolean = false;
  public returnUsers: boolean = false;

  constructor(params: Partial<SearchFilters>) {
    //if (params.searchTerm) {
    //    this.searchTerm = params.searchTerm;
    //}
    if (params.filters && params.filters.length > 0) {
      this.filters = params.filters;
    }
    if (params.returnBusinesses) {
      this.returnBusinesses = params.returnBusinesses;
    }
    if (params.returnCustomers) {
      this.returnCustomers = params.returnCustomers;
    }
    if (params.returnMerchants) {
      this.returnMerchants = params.returnMerchants;
    }
    if (params.returnTransactions) {
      this.returnTransactions = params.returnTransactions;
    }
    if (params.returnUsers) {
      this.returnUsers = params.returnUsers;
    }
  }
}
